import type { ApiResponse } from "@melhot/shared";

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL ?? "https://api.melhot.com.br";
const TOKEN_KEY = "melhot_admin_token";

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY) ?? "";
}

export function setAdminToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAdminToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getAdminToken()}`,
      ...(init?.headers ?? {})
    }
  });
  const payload = (await response.json()) as ApiResponse<T>;
  if ("error" in payload) throw new Error(payload.error.message);
  return payload.data;
}

export const adminApi = {
  login: (body: { email: string; password: string }) =>
    request<{ token: string }>("/api/admin/auth/login", { method: "POST", body: JSON.stringify(body) }),
  overview: () => request<any>("/api/admin/overview"),
  checkouts: () => request<any[]>("/api/admin/checkouts"),
  checkout: (id: string) => request<any>(`/api/admin/checkouts/${id}`),
  payments: () => request<any[]>("/api/admin/payments"),
  orders: () => request<any[]>("/api/admin/orders"),
  products: () => request<{ connected: boolean; products: any[] }>("/api/admin/products"),
  customers: () => request<{ connected: boolean; customers: any[] }>("/api/admin/customers"),
  webhooks: () => request<any[]>("/api/admin/webhooks"),
  retryShopify: (publicId: string) =>
    request<any>(`/api/admin/orders/${publicId}/retry-shopify`, { method: "POST" }),
  testEmail: (to: string) =>
    request<any>("/api/admin/email/test", { method: "POST", body: JSON.stringify({ to }) }),
  pixelSettings: () => request<any>("/api/admin/settings/pixel"),
  updatePixelSettings: (body: any) =>
    request<any>("/api/admin/settings/pixel", { method: "POST", body: JSON.stringify(body) }),
  trafficAttribution: () => request<any[]>("/api/admin/traffic-attribution"),
  analyticsSummary: () => request<any>("/api/admin/analytics/summary")
};
